import React from "react";
// global context (this.props.data)
import { WithContext } from "store/DataProvider";
// react-bootstrap components
import { Container, Row, Alert } from "react-bootstrap";
// custom component
import Accordions from "directiveNitrate/accordions/component";
import FloatingSaveButton from "buttons/FloatingSaveButton";

class FicheChantier extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      accordionsData: [
        {
          title: "Agrément",
          inputGroups: [
            {
              name: "Informations d'agrément",
              fields: [
                {
                  type: "text",
                  label: "N° d'agrément",
                  name: "numAgrement",
                },
                {
                  type: "text",
                  label: "N° Assurance RC",
                  name: "numAssuranceRc",
                },
              ],
            },
          ],
        },
        {
          title: "Commande",
          inputGroups: [
            {
              name: "Détails de la commande",
              fields: [
                {
                  type: "react-select",
                  label: "Origine de la commande",
                  name: "origineCmd",
                  options: [
                    { id: 1, label: "Oral" },
                    { id: 2, label: "Contrat" },
                    { id: 3, label: "Texto" },
                    { id: 4, label: "Mail" },
                    { id: 0, label: "Indéterminé" },
                  ],
                },
                {
                  type: "date",
                  label: "Date de signature du contrat",
                  name: "dateSignContrat",
                },
              ],
            },
          ],
        },
        {
          title: "Réalisation",
          inputGroups: [
            {
              name: "Préparation de l'intervention",
              fields: [
                {
                  type: "text",
                  label: "Matériel à utiliser",
                  name: "materielInterv",
                },
                {
                  type: "text",
                  label: "Par",
                  name: "parQuiInterv",
                },
                {
                  type: "radio",
                  label: "Si produits fournis par le client : Conformités des produits avec la commande",
                  name: "confPrdClient",
                  options: [
                    { id: 1, label: "Oui" },
                    { id: 2, label: "Non" },
                    { id: 0, label: "Indéterminé" },
                  ],
                },
                {
                  type: "radio",
                  label: "En arrivant sur site : Interventions possibles selon le descriptif ci-dessus",
                  name: "intervPoss",
                  options: [
                    { id: 1, label: "Oui" },
                    { id: 2, label: "Non" },
                    { id: 0, label: "Indéterminé" },
                  ],
                },
              ],
            },
          ],
        },
        {
          title: "Après l'application",
          inputGroups: [
            {
              name: "Exécution et suivi",
              fields: [
                {
                  type: "radio",
                  label: "Zones à traiter respectées",
                  name: "zoneTrait",
                  options: [
                    { id: 1, label: "Oui" },
                    { id: 2, label: "Non" },
                    { id: 0, label: "Indéterminé" },
                  ],
                },
                {
                  type: "radio",
                  label: "Doses et produits respectés",
                  name: "dosePrdResp",
                  options: [
                    { id: 1, label: "Oui" },
                    { id: 2, label: "Non" },
                    { id: 0, label: "Indéterminé" },
                  ],
                },
                {
                  type: "radio",
                  label: "Consignes d'exécution respectées",
                  name: "consiResp",
                  options: [
                    { id: 1, label: "Oui" },
                    { id: 2, label: "Non" },
                    { id: 0, label: "Indéterminé" },
                  ],
                },
                {
                  type: "radio",
                  label: "Incidents ou imprévus survenus",
                  name: "incident",
                  options: [
                    { id: 1, label: "Oui" },
                    { id: 2, label: "Non" },
                    { id: 0, label: "Indéterminé" },
                  ],
                },
                {
                  type: "react-select",
                  label: "Gestion des effluents par l'entreprise",
                  name: "gestEffluent",
                  options: [
                    { id: 1, label: "Oui au champ" },
                    { id: 2, label: "Oui à la ferme" },
                    { id: 3, label: "Non" },
                    { id: 0, label: "Indéterminé" },
                  ],
                },
                {
                  type: "radio",
                  label: "Gestion des EVPP par le client",
                  name: "gestEvppClient",
                  options: [
                    { id: 1, label: "Oui" },
                    { id: 2, label: "Non" },
                    { id: 0, label: "Indéterminé" },
                  ],
                },
              ],
            },
          ],
        },
        {
          title: "Consignes de sécurité",
          inputGroups: [
            {
              name: "Conformité réglementaire",
              fields: [
                {
                  type: "radio",
                  label: "Respect de la ZNT",
                  name: "respectZnt",
                  options: [
                    { id: 1, label: "Oui" },
                    { id: 2, label: "Non" },
                    { id: 0, label: "Indéterminé" },
                  ],
                },
                {
                  type: "radio",
                  label: "Respect du DVP (dispositif végétalisé permanent) de 5 ou 20 m",
                  name: "respectDvp",
                  options: [
                    { id: 1, label: "Oui" },
                    { id: 2, label: "Non" },
                    { id: 0, label: "Indéterminé" },
                  ],
                },
              ],
            },
          ],
        },
      ],
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleReactSelectChange = this.handleReactSelectChange.bind(this);
    this.save = this.save.bind(this);
  }

  handleChange(e) {
    const target = e.target;
    const type = target.type;
    let value = target.value;
    const name = target.name;
    // pour pouvoir accéder au nativeEvent
    if (type === "select-one") e.persist();

    let newValue = value;
    if (type === "select-one") {
      if (value) {
        const nativeTarget = e.nativeEvent.target;
        const index = nativeTarget.selectedIndex;
        const label = nativeTarget[index].text;
        // ajouter l'id et le label de l'option sélectionnée
        newValue = [{ id: Number(value), label: label }];
      } else {
        newValue = [];
      }
    } else if (type === "number" && value !== "") {
      // tronquer au nombre de décimales souhaité
      const decimals = target.getAttribute("decimals");
      newValue = +Number(target.value).toFixed(decimals);
    } else if (type === "radio") {
      newValue = Number(value);
    }
    
    this.props.data.updateFicheChantierField(name, newValue);
  }

  handleReactSelectChange(name, option) {
    this.props.data.updateFicheChantierField(name, [option]);
  }

  async save() {
    const isSuccess = await this.props.data.modifierFicheChantier(this.props.data.ficheChantier);
    if (isSuccess) {
      setTimeout(() => window.location.reload(), 2000);
    }
  }

  render() {
    // Date de signature du contrat : visible uniquement si Origine = Contrat (id 2)
    const origineCmd = this.props.data.ficheChantier.origineCmd;
    const showDateSignContrat =
      Array.isArray(origineCmd) && origineCmd[0] && origineCmd[0].id === 2;
    const accordionsData = this.state.accordionsData.map((acc) => ({
      ...acc,
      inputGroups: acc.inputGroups.map((group) => ({
        ...group,
        fields: group.fields.filter(
          (f) => f.name !== "dateSignContrat" || showDateSignContrat
        ),
      })),
    }));

    return (
      <Container className="mt-3">
        <Row>
          <Alert variant="success" className="text-center w-100 mb-0">
            <Alert.Heading>Fiche de chantier</Alert.Heading>
          </Alert>
        </Row>
        <Row>
          <Accordions
            accordionsData={accordionsData}
            formData={this.props.data.ficheChantier}
            handleChange={this.handleChange}
            handleReactSelectChange={this.handleReactSelectChange}
            hideGroupHeaders={true}
          />
        </Row>
        <FloatingSaveButton title="Enregistrer" onClickFn={this.save} />
      </Container>
    );
  }
}

export default WithContext(FicheChantier);

